import { type Meta } from '../types/docs';

export const PERSON_TAGGED_TYPES = ['face_detected', 'boundary_box_drawn', 'no_boundary_box'] as const;

export type PersonTaggedType = (typeof PERSON_TAGGED_TYPES)[number];

const META: Meta = {
  description:
    'Fired when a user tags a person in an asset, including change-person re-tags on existing clip-person rows. `type` describes how they were tagged: via a detected face, a manually drawn bounding box, or with no bounding box (faceless).',
  name: 'person_tagged',
  params: [
    {
      description: 'How the person was tagged in the asset',
      name: 'type',
      required: true,
      type: 'enum',
      values: [...PERSON_TAGGED_TYPES],
    },
    {
      description: 'The id of the tagged person',
      name: 'person_id',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
